import { startCase } from 'lodash';

import { Text, isTruthy } from 'common';

import { FlowTemplatePreviewPanelGroup } from './Group';

interface FlowTemplatePreviewPanelTagProps {
  title: string;
  tags: string[] | undefined;
}

export function FlowTemplatePreviewPanelTag(props: FlowTemplatePreviewPanelTagProps) {
  const { title, tags } = props;

  if (!isTruthy(tags?.length)) {
    return null;
  }

  return (
    <FlowTemplatePreviewPanelGroup title={title}>
      {tags.map((tag) => (
        <Text key={tag} variant="body2">
          {startCase(tag)}
        </Text>
      ))}
    </FlowTemplatePreviewPanelGroup>
  );
}
